<form [formGroup]="searchForm" #form="ngForm" (ngSubmit)="onSubmit()" class="agec-form">
    <div class="search-block">
        <div class="search-input-container">
            <h-search-input
                [controlName]="'searchInput'"
                [id]="'search-agec'"
                [name]="'search-agec'"
                class="search-input"
                [autocomplete]="'off'"
                [errorManagement]="false"
                [ariaAutoComplete]="'list'"
                [ariaControls]="'search-address'"
                [attr.data-testid]="'search-agec-input'"
                [attr.aria-describedby]="
                    form.submitted && (searchInput?.errors?.required || skuNotFound) ? 'error-block-id' : null
                "
                [attr.aria-invalid]="form.submitted && (searchInput?.errors?.required || skuNotFound) ? true : null"
                label="'Saisir la référence produit'"
                i18n-label="@@hermes.environment.search-text"
                (handleKeyDown)="handleKeyDown($event)">
                @if (skuNotFound) {
                <h-message-block
                    errors
                    [type]="'error'"
                    [id]="'error-block-id'"
                    [showBackground]="false"
                    [autoAddPadding]="false">
                    <ng-container i18n="@@hermes.environment.error-message">
                        La référence saisie peut être incorrecte, ne fait pas partie des articles concernés par la loi
                        AGEC ou ne possède pas de caractéristiques environnementales spécifiques.
                    </ng-container>
                </h-message-block>
                }
            </h-search-input>
        </div>
    </div>
</form>
